import React from "react";
import { GET_LIST, Link } from "react-admin";
import { Card, CardContent, Button, CardHeader } from "@material-ui/core";
import dataProviderFactory from "../dataProvider";

import moment from 'moment-timezone';
import styled from "styled-components";
import RentalPopOver from "../components/rentalPopOver";
import {
  map,
  curry,
  filter,
  isNil,isEmpty,
  assoc,
  propEq,
  find,
  range,
  when,
  complement,
  prop,
  sortBy,
  sortWith,
  ascend,
  path, uniq, indexOf,
  head
} from "ramda";
import * as R from "ramda";
import LinearProgress from "@material-ui/core/LinearProgress";
import { parse } from "query-string";
import ArrowUpward from "@material-ui/icons/ArrowUpward";
import Warning from "@material-ui/icons/Warning";
moment.tz.setDefault("Europe/Madrid");
const StyledLink = styled(Link)`
  :link {
    color: #000000;
    text-decoration: underline;
  }
  :visited {
    color: #000000;
  }
  :hover {
    color: #000000;
  }
  :active {
    color: #000000;
  }
`;
const StyledError = styled(Warning)`
  height: 18px !important;
`;

const Grid = styled.div({
  display: "flex",
  flexDirection: "row",
  flexGrow: 1,
  maxWidth: "82vw",
  justifyContent: "flext-start"
});

const View = styled.span(props => ({
  color: props.color || "initial",
  fontWeight: props.weight || "normal",
  padding: "2px",
  backgroundColor: props.background,
  display: "inline-block",
  backgroundImage: props.shade
    ? "url(data:image/gif;base64,R0lGODlhDAAMAIAAAP///wAAACH5BAEAAAAALAAAAAAMAAwAAAIUhI8QmcvnnpImPstwo5Nq9EEcUAAAOw==)"
    : "none"
}));

const MainView = styled(View)(props => ({
  marginRight: "2px",
  flexGrow: 1,
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
}));
const AuxView = styled(View)(props => ({
  minWidth: props.small ? "15%" : "20%",
  padding: "0px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
}));

const Table = styled.div({
  display: "flex",
  overflow: "scroll",
  width: "90vw"
});

const KmSpan = styled.span({
  fontSize: "12px",
  fontWeight: "900",
  textDecoration: "underline",
  color: "red",
  backgroundColor: "white"
});

const Cell = props => {
  const {
    textValue,
    secundaryTextValue,
    color,
    secundaryColor,
    textColor,
    textWeight,
    weekend,
    smallAux,
    children,
    extraText,
    style
  } = props;
  return (
    <React.Fragment>
      <MainView
        background={color}
        color={textColor}
        weight={textWeight}
        shade={weekend}
        style={style}
      >
        {" "}
        {textValue} {children}&nbsp;<KmSpan>{extraText}</KmSpan>
      </MainView>
      <AuxView
        background={secundaryColor || color}
        shade={weekend}
        small={smallAux}
        style={style}
      >
        {" "}
        {secundaryTextValue}{" "}
      </AuxView>
    </React.Fragment>
  );
};

const DateColumn = styled.div(props => ({
  display: "flex",
  flexDirection: "column",
  backgroundColor: props.color,
  border: "1px solid #ffffff"
}));

const Column = styled.div(props => ({
  display: "flex",
  flexDirection: "column",
  backgroundColor: props.color,
  border: "1px solid #ffffff",
  minWidth: "15rem",
  fontSize: "13px"
}));

const WeekDay = styled.div({
  width: "5.5rem"
});
const Date = styled.div({
  width: "7rem"
});

const Row = styled.div({
  display: "flex",
  height: "1.5rem",
  flexWrap: "nowrap",
  marginBottom: "2px",
  marginRight: "5px"
});

const BackButton = styled.div({
  marginBottom: "1rem"
});

const nilMap = R.when(R.complement(R.isNil));

const isWeekend = day => day.isoWeekday() === 6 || day.isoWeekday() === 7;

const DISTANT_PAST = 0;
const DISTANT_FUTURE = 1e15;

class GpsSchedule extends React.Component {
  async getLocations() {
    const dataProvider = await dataProviderFactory("rest");
    const locations = await dataProvider(GET_LIST, "locations", {
      filter: { only_bases: "true" },
      pagination: {
        page: 1,
        perPage: 999
      },
      sort: { field: this.props.created_at, order: "DESC" }
    });
    return locations;
  }

  async getHolidays(startDate, endDate, location) {
    const dataProvider = await dataProviderFactory("rest");
    const holidays = dataProvider(GET_LIST, "holidays", {
      filter: {
        startDate: startDate.format("YYYY-MM-DD"),
        endDate: endDate.format("YYYY-MM-DD"),
        location_id: location
      },

      pagination: {
        page: 1,
        perPage: 99999
      },
      sort: { field: this.props.created_at, order: "DESC" }
    });

    return holidays;
  }

  async fetchData(startDate, endDate, location) {
    const dataProvider = await dataProviderFactory("rest");

    const getDisplacedVehicles = dataProvider(GET_LIST, "displaced_vehicles", {
      filter: {},
      pagination: {
        page: 1,
        perPage: 99999
      },
      sort: { field: this.props.created_at, order: "DESC" }
    });

    const getItemLocations = dataProvider(GET_LIST, "item_locations", {
      filter: {
        type: "gps_device",
        endDate: moment(endDate).format("YYYYMMDD"),
        date: moment(startDate).format("YYYYMMDD")
      },
      pagination: {
        page: 1,
        perPage: 99999
      },
      sort: { field: this.props.created_at, order: "DESC" }
    });
    console.log(getItemLocations) 
    const getGpsDevices = await dataProvider(GET_LIST, "gps_schedule", {
      filter: {
        schedule: true,
        include_events_start: startDate.format("YYYYMMDD"),
        include_events_end: endDate.format("YYYYMMDD")
      },
      pagination: {
        page: 1,
        perPage: 9999
      },
      sort: {}
    });
    console.log(getGpsDevices) 
    const [devices, locations, itemLocations, displacedVehicles] = await Promise.all([
      getGpsDevices,
      this.getLocations(),
      getItemLocations, getDisplacedVehicles
    ]);

    const updatedDevices = map(
      d =>
        assoc(
          "displacement",
          this.isVehicleDisplaced(d, displacedVehicles),
           assoc(
            "location",
            this.locationDevice(
              d,
              locations.data,
              itemLocations.data
            ),
            d
          ) 
        ), devices.data
    );
    
    if (location === 0) {

      console.log(updatedDevices) 

      return sortWith(
        [
          ascend(path(["location", "screen_order"])),
          ascend(prop("id"))
        ],
        updatedDevices
      );
    } else {
      const specialDevices = filter(
        obj => obj.location != undefined && 
        obj.location.id === location, 
        updatedDevices
      );

      const gpsWithTransfers = filter(obj => {
        const sortedTransfers = sortBy(
          path(["transfer_date"]),
          filter(
            obj =>
              moment(obj.transfer_date).isSameOrBefore(endDate) &&
              moment(obj.transfer_date).isSameOrAfter(startDate),
            sortBy(path(["transfer_date"]), obj.transfers)
          )
        );

        return (
          (!R.isNil(obj.location) &&
            R.prop("id", obj.location) !== location &&
            !R.isEmpty(sortedTransfers) &&
            R.prop("location_id_1", R.head(sortedTransfers)) === location) ||
          R.prop("location_id_2", R.head(sortedTransfers)) === location
        );
      }, updatedDevices);

     const locationDevices = R.filter(
        R.pathEq(["location", "id"], location),
        updatedDevices
      );

      const finalList = sortBy(
        path(["id"]),
        locationDevices.concat(specialDevices).concat(gpsWithTransfers)
      );
     
      return R.uniq(finalList);
    }

  }

  isVehicleDisplaced = (vehicle, displacedVehicles) => {
    const vehicleDisplaced = find(
      propEq("id", vehicle.id),
      displacedVehicles.data
    );
    return {
      displaced: vehicleDisplaced.displaced,
      displaceDate: vehicleDisplaced.displacedDate
    };
  };

  locationDevice = (device, locations, itemLocations) => {
    const itemLocation = find(propEq("item_id", device.id), itemLocations);
    const optionalMap = when(complement(isNil));
    return optionalMap(l => find(propEq("id", l.location_id_2), locations))(
      itemLocation
    );
  };

  async setData() {
    const {
      date_start,
      date_end,
      location,
      op_date_begin,
      op_date_end
    } = parse(this.props.location.search);
    const startDate = moment(date_start);
    const endDate = moment(date_end);
    const opDateBegin = !isNil(op_date_begin) ? moment(op_date_begin) : null;
    const opDateEnd = !isNil(op_date_end) ? moment(op_date_end) : null;

    // const reloading = false;
    await this.updateState(
      startDate,
      endDate,
      Number(location),
      opDateBegin,
      opDateEnd
    );
  }

  setReload() {
    this.setState({ reloading: true });
  }

  async componentDidUpdate(prevProps) {
    if (this.props.location.search !== prevProps.location.search) {
      return await this.setData();
    }
  }

  async componentDidMount() {
    this.setData();
  }

  updateState = async (
    startDate,
    endDate,
    location,
    opDateBegin,
    opDateEnd
  ) => {

    const data = await this.fetchData(startDate, endDate, location);
    const locations = await this.getLocations();
    const holidays = await this.getHolidays(startDate, endDate, location);
    this.setState({
      reloading: false,
      data,
      startDate,
      endDate,
      location,
      holidays,
      locations: locations.data,
      opDateBegin,
      opDateEnd
    });
  };

  sortedDayList = (start, end, nextEventDate, forceAdd = false) => {
    const add = (day, offset) => day.clone().add(offset, "days");
    if (end.isSame(nextEventDate, "day")) {
      return map(
        curry(add)(start),
        range(0, end.startOf('day').diff(start.startOf('day'), "days") + (forceAdd ? 1 : 0))
      );
    }
    return map(curry(add)(start), range(0, end.startOf('day').diff(start.startOf('day'), "days") + 1));
  /*   const add = (day, offset) => day.clone().add(offset, "days");
    return map(curry(add)(start), range(0, end.diff(start, "days") + 1)); */
  };

  blockForHoldEvent = (
    hold,
    device,
    nextEvent,
    nextEventDate,
    startLimit,
    endLimit,
    opDateBegin,
    opDateEnd
  ) => {
    const start = moment.max(moment(hold.start_date), startLimit);

    const end = R.reduce(moment.min, moment(DISTANT_FUTURE), [
      moment(hold.end_date),
      endLimit,
      nilMap(moment, nextEventDate) || moment(DISTANT_FUTURE)
    ]);

    const days = this.sortedDayList(start, end, nextEventDate);
    const retirementDate = nilMap(moment, prop("retirement_date", device));

    const isRetirement =
      retirementDate && retirementDate.isSame(hold.start_date, "day");

    const cell = day => {
      if (isRetirement) {
        return (
          <Cell
            extraText=""
            textValue={
              <React.Fragment>
                H: {this.buildLinkForHold(hold, device.model)}
              </React.Fragment>
            }
            secundaryTextValue={<RentalPopOver>{hold.notes}</RentalPopOver>}
            color={"#FF00CC"}
            weekend={isWeekend(day)}
            smallAux={true}
            style={{
              borderBottom: day.isSame(moment(opDateEnd)) ? "3px dashed red" : "",
              borderTop: day.isSame(moment(opDateBegin)) ? "3px dashed red" : ""
            }}
          />
        );
      }
      return (
        <Cell
          extraText=""
          textValue={
            <React.Fragment>
              H: {this.buildLinkForHold(hold, device.model)}
            </React.Fragment>
          }
          secundaryTextValue={"H"}
          color={"#FF00CC"}
          weekend={isWeekend(day)}
          smallAux={true}
          style={{
            borderBottom: day.isSame(moment(opDateEnd)) ? "3px dashed red" : "",
            borderTop: day.isSame(moment(opDateBegin)) ? "3px dashed red" : ""
          }}
        />
      );
    };

    return map(day => <Row id={hold.id}>{cell(day)}</Row>, days);
  };

  buildLinkTourRental = (rental, title) => {
    return (
      <StyledLink
        to={{
          pathname: `/${rental.type === 2 ? "rental_clients" : "tour_clients"
            }/${rental.id}/show`
        }}
        target="_blank"
      >
        {title}
      </StyledLink>
    );
  };

  buildLinkForTransfer = (tranfer, title) => {
    return (
      <StyledLink to={{ pathname: `/transfers/${tranfer.id}` }} target="_blank">
        {title}
      </StyledLink>
    );
  };

  buildLinkForGps = device => {
    return (
      <StyledLink
        to={{ pathname: `/gps_devices/${device.id}` }}
        target="_blank"
      >
        {device.model}
      </StyledLink>
    );
  };

  buildLocationGps = device => {
    const location = device.location
    return (
      <span>
        {location.location3letter_name}
      </span>
    );
  };

  buildLocationColorGps = device => {
    const location = device.location
    return location.color;
  };


  buildLinkForHold = (hold, title) => {
    return (
      <StyledLink to={{ pathname: `/holds/${hold.id}` }} target="_blank">
        {title}
      </StyledLink>
    );
  };

  buildLinkForTourGuide = (tour, title) => {
    return (
      <StyledLink to={{ pathname: `/tours/${tour.id}` }} target="_blank">
        {title}
      </StyledLink>
    );
  };

  blockForRental = (
    rental,
    device,
    nextEvent,
    nextEventDate,
    startLimit,
    endLimit,
    opDateBegin,
    opDateEnd
  ) => {
    const start = moment.max(moment(rental.date_1), startLimit);
    const end = moment.min(moment(rental.date_2), endLimit);

    const days = this.sortedDayList(start, end, nextEventDate);

    const isTour = R.propEq("type", 1);
    const driver = R.prop("driver", rental);
    const booking = R.prop("booking", rental);
    const country = R.prop("country", driver);

    const cell = day => {
      const isSameDayBegin =
        day.format("YYYY-MM-DD") === moment(opDateBegin).format("YYYY-MM-DD");
      const isSameDayEnd =
        day.format("YYYY-MM-DD") === moment(opDateEnd).format("YYYY-MM-DD");

      if (!isTour(rental)) {
        return (
          <Cell
            extraText=""
            textValue={
              <React.Fragment>
                Rental: {this.buildLinkTourRental(rental, rental.id)}{" "}
              </React.Fragment>
            }
            secundaryTextValue={
              <RentalPopOver>
                {booking.r_first_name} {booking.r_last_name}
                {", "}
                {prop("country", country)}
                {", "}
                {rental.rental_lenght} days
              </RentalPopOver>
            }
            style={{
              borderBottom: isSameDayEnd ? "3px dashed red" : "",
              borderTop: isSameDayBegin ? "3px dashed red" : ""
            }}
            color={
              rental.agency_id === 1 ||
                rental.agency_id === 6 ||
                R.isNil(rental.agency_id)
                ? day.format("YYYY-MM-DD") === start.format("YYYY-MM-DD") &&
                  rental.time_1 === "18:00:00"
                  ? "#FFCC66"
                  : day.format("YYYY-MM-DD") === end.format("YYYY-MM-DD") &&
                    rental.time_2 === "10:00:00"
                    ? "#FFCC66"
                    : "red"
                : "#FFFF00"
            }
            weekend={isWeekend(day) || this.isHoliday(day)}
            smallAux={true}
          ></Cell>
        );
      } else {
        return (
          <Cell
            extraText=""
            textValue={
              <React.Fragment>
                Tour: {this.buildLinkTourRental(rental, rental.id)}
              </React.Fragment>
            }
            secundaryTextValue={
              <RentalPopOver>
                **{" "}
                {path(["booking", "tour", "tour_name", "tour_name_en"], rental)}{" "}
                -- {moment(rental.date_1).format("MMM")}{" "}
                {moment(rental.date_1).format("DD")}-
                {moment(rental.date_2).format("DD")}{" "}
                {moment(rental.date_2).format("YYYY")} **{" "}
                {booking.r_first_name} {booking.r_last_name}
                {", "}
                {prop("country", country)}
                {", "}
              </RentalPopOver>
            }
            style={{
              borderBottom: isSameDayEnd ? "3px dashed red" : "",
              borderTop: isSameDayBegin ? "3px dashed red" : ""
            }}
            color={"#CC9999"}
            weekend={isWeekend(day) || this.isHoliday(day)}
            smallAux={true}
          />
        );
      }
    };
   /*  let locat = null
    for (let index = 0; index < device.location.length; index++) {
      locat = device.location[index].location3letter_name;
    } */
    return map(day => <Row id={rental.id}>{cell(day)}</Row>, days);
  };

  blockForTransfer = (
    transfer,
    device,
    nextEvent,
    nextEventDate,
    startLimit,
    endLimit,
    opDateBegin,
    opDateEnd
  ) => {
    const start = moment.max(moment(transfer.transfer_date), startLimit);
    const end = moment.min(moment(transfer.setup_date), endLimit);

    const days = this.sortedDayList(start, end, nextEventDate);

    return map(day => {
      const isSameDayBegin =
        day.format("YYYY-MM-DD") === moment(opDateBegin).format("YYYY-MM-DD");
      const isSameDayEnd =
        day.format("YYYY-MM-DD") === moment(opDateEnd).format("YYYY-MM-DD");
      return (
        <Row id={transfer.id} key={`${device.id}_${day}`}>
          <Cell
            extraText=""
            textValue={
              <React.Fragment>
                Transfer: {this.buildLinkForTransfer(transfer, transfer.id)}
              </React.Fragment>
            }
            secundaryTextValue={<RentalPopOver>{transfer.notes}</RentalPopOver>}
            color={"#9966FF"}
            weekend={isWeekend(day) || this.isHoliday(day)}
            smallAux={true}
            style={{
              borderBottom: isSameDayEnd ? "3px dashed red" : "",
              borderTop: isSameDayBegin ? "3px dashed red" : ""
            }}
          />
        </Row>
      );
    }, days);
  };

  blockForGuideTour = (
    tour,
    device,
    nextEvent,
    nextEventDate,
    startLimit,
    endLimit,
    description,
    opDateBegin,
    opDateEnd
  ) => {
    const start = moment.max(moment(tour.effective_start_date), startLimit);
    const end = moment.min(moment(tour.effective_end_date), endLimit);

    const days = this.sortedDayList(start, end, nextEventDate);

    return map(day => {
      const isSameDayBegin =
        day.format("YYYY-MM-DD") === moment(opDateBegin).format("YYYY-MM-DD");
      const isSameDayEnd =
        day.format("YYYY-MM-DD") === moment(opDateEnd).format("YYYY-MM-DD");
      return (
        <Row id={tour.id}>
          <Cell
            extraText=""
            textValue={
              <React.Fragment>
                {description}: {this.buildLinkForTourGuide(tour, tour.id)}
              </React.Fragment>
            }
            secundaryTextValue={
              <RentalPopOver>
                ** {path(["tour_name", "tour_name_en"], tour)} --{" "}
                {moment(tour.effective_start_date).format("MMM")}{" "}
                {moment(tour.effective_start_date).format("DD")}-
                {moment(tour.effective_end_date).format("DD")}{" "}
                {moment(tour.effective_end_date).format("YYYY")} **{" "}
                {description}
              </RentalPopOver>
            }
            color={"#66CCFF"}
            weekend={isWeekend(day) || this.isHoliday(day)}
            smallAux={true}
            style={{
              borderBottom: isSameDayEnd ? "3px dashed red" : "",
              borderTop: isSameDayBegin ? "3px dashed red" : ""
            }}
          />
        </Row>
      );
    }, days);
  };

  daysForEvent = (
    { event, type },
    device,
    nextEvent,
    nextEventDate,
    start,
    end,
    opDateBegin,
    opDateEnd
  ) => {
    switch (type) {
      case "hold":
        return this.blockForHoldEvent(
          event,
          device,
          nextEvent,
          nextEventDate,
          start,
          end,
          opDateBegin,
          opDateEnd
        );
      case "transfer":
        return this.blockForTransfer(
          event,
          device,
          nextEvent,
          nextEventDate,
          start,
          end,
          opDateBegin,
          opDateEnd
        );
      case "rental":
        return this.blockForRental(
          event,
          device,
          nextEvent,
          nextEventDate,
          start,
          end,
          opDateBegin,
          opDateEnd
        );
      case "guide_gps":
        return this.blockForGuideTour(
          event,
          device,
          nextEvent,
          nextEventDate,
          start,
          end,
          "Guide",
          opDateBegin,
          opDateEnd
        );
      default:
        return this.blockForRental(
          event,
          device,
          nextEvent,
          nextEventDate,
          start,
          end,
          opDateBegin,
          opDateEnd
        );
    }
  };

  locationForEvent = ({ event, type }) => {
    switch (type) {
      case "hold":
        return null;
      case "transfer":
        return event.location_2;
      case "rental":
        return event.location_2;
      case "guide_gps":
        return event.location_2;
      default:
        return event.location_2;
    }
  };

  deviceAtBase = (
    device,
    prevEventDate,
    nextEventDate,
    location,
    startLimit,
    endLimit,
    opDateBegin,
    opDateEnd
  ) => {
    const start = moment.max(
      moment(prevEventDate || DISTANT_PAST).add(1, "day"),
      startLimit
    );
    const end = moment.min(
      moment(nextEventDate || DISTANT_FUTURE).add(-1, "day"),
      endLimit
    );

    //const days = this.sortedDayList(start, end);
    const days = this.sortedDayList(start, end, nextEventDate, true);

    const cell = day => {
      const isSameDayBegin =
        day.format("YYYY-MM-DD") === moment(opDateBegin).format("YYYY-MM-DD");
      const isSameDayEnd =
        day.format("YYYY-MM-DD") === moment(opDateEnd).format("YYYY-MM-DD");
      return (
        <Cell
          extraText=""
          textValue={`${device.model}`}
          //textValue={this.buildLinkForGps(device)}
         // secundaryTextValue={this.buildLocationGps(device)} 
          secundaryTextValue= {
              `${R.prop("location3letter_name", location)}` 
          }
          //secundaryTextValue={R.prop("location3letter_name", location)}
          color={"#99FF99"}
          //secundaryColor={this.buildLocationColorGps(device)} 
          secundaryColor={R.prop("color", location)}
          weekend={isWeekend(day) || this.isHoliday(day)}
          smallAux={true}
          style={{
            borderBottom: isSameDayEnd ? "3px dashed red" : "",
            borderTop: isSameDayBegin ? "3px dashed red" : ""
          }}
        />
      );
    };
   
    return map(day => <Row id={`${device.id}`}>{cell(day)}</Row>, days);
  };

  isHoliday = day => {
    const { holidays } = this.state;
    const hasHollidays = [];
    map(hd => {
      if (moment(hd.date).format("YYYY-MM-DD") === day.format("YYYY-MM-DD")) {
        hasHollidays.push(hd);
      }
    }, prop("data", holidays));
    return R.length(hasHollidays) > 0;
  };

  buildTimeline = (start, end, opDateBegin, opDateEnd) => {
    const days = this.sortedDayList(start, end);
    const rows = map(day => {
      return (
        <Row
          id={`${start.unix()}_${Math.random()}`}
          key={`${start.unix()}_${Math.random()}`}
        >
          <WeekDay
            key={`d_${day.format("dddd")}_${Math.random()}`}
            style={{
              borderBottom: day.isSame(moment(opDateEnd))
                ? "3px dashed red"
                : "",
              borderTop: day.isSame(moment(opDateBegin))
                ? "3px dashed red"
                : "",
              color: isWeekend(day) || this.isHoliday(day) ? "red" : null
            }}
          >
            {day.format("dddd")}
          </WeekDay>
          <Date
            style={{
              color: isWeekend(day) || this.isHoliday(day) ? "red" : null,
              borderBottom: day.isSame(moment(opDateEnd))
                ? "3px dashed red"
                : "",
              borderTop: day.isSame(moment(opDateBegin)) ? "3px dashed red" : ""
            }}
          >
            {day.format("DD-MM-YYYY")}
          </Date>
        </Row>
      );
    }, days);

    return <DateColumn>{rows}</DateColumn>;
  };

  buildEvents = (devices, start, end, opDateBegin, opDateEnd, location) => {
    const locat = ['MAD', 'BAR', 'MAL', 'LIS', 'BIL'];

    const SortGPSLocation = arr => {
      let newArray = [];

      arr.sort((left, right) => {
        return moment.utc(left.purchase_date).diff(moment.utc(right.purchase_date));
      });

      if (location === 0) {
        locat.forEach(base => {
          arr.forEach(data => { //ordenando por ubicaciones
            const location = data.location
            if(location !== undefined){
              if (base === location.location3letter_name) {
                newArray.push(data)
              }
            } 
          });
        });
      } else {
        arr.forEach(data => { //ordenando por ubicaciones 
            newArray.push(data) 
        });
      }

      return newArray;
    };
    const result = SortGPSLocation(devices);
   
    return map(
      curry(this.buildEventsForDevice)(start, end, opDateBegin, opDateEnd),
      result
    );
  };

  buildEventsForDevice = (
    startLimit,
    endLimit,
    opDateBegin,
    opDateEnd,
    device
  ) => {
    // abstracts events in a boxed record for easier sorting since date props have diferent keys, startDate and endDate functions returns the start date and end date for a given box
    const buildEventRecords = (events, type, startKey, endKey) =>
      map(event => ({ type, event, startKey, endKey }), events);
    const startDate = R.converge(R.prop, [R.prop("startKey"), R.prop("event")]);
    const endDate = R.converge(R.prop, [R.prop("endKey"), R.prop("event")]);
    const events = R.unnest([
      buildEventRecords(device.transfers || [], "transfer", "transfer_date", "setup_date"),
      buildEventRecords(device.rentals || [], "rental", "date_1", "date_2"),
      buildEventRecords(device.holds || [], "hold", "start_date", "end_date"),
      buildEventRecords(device.tours || [], "guide_gps", "effective_start_date", "effective_end_date")
    ]);

    const sortedEvents = R.sortBy(startDate, events);
    const eventsTuples = R.concat(
      R.aperture(2, sortedEvents),
      R.filter(R.identity, [nilMap(e => [e, null], R.last(sortedEvents))])
    );

    const firstEventDate = nilMap(
      moment,
      nilMap(startDate, R.head(sortedEvents))
    );
    const initialEvents = (() => {
      if(device.id == 52){
        console.log(device)
      }
      if (R.isNil(firstEventDate) || firstEventDate.isAfter(startLimit)) {
        return this.deviceAtBase(
          device,
          undefined,
          firstEventDate,
          device.location,
          startLimit,
          endLimit,
          opDateBegin,
          opDateEnd
        );
      }
      return [];
    })();

    const [_, eventsBlocks] = R.mapAccum(
      (location, [event, next]) => {
        const nextEventDate = nilMap(startDate)(next);
        const lastLocation = nilMap(this.locationForEvent)(event) || location;

        const daysForEvent = this.daysForEvent(
          event,
          device,
          R.prop('event', next),
          nextEventDate,
          startLimit,
          endLimit,
          opDateBegin,
          opDateEnd
        );
       
        const daysForBase = this.deviceAtBase(
          device,
          endDate(event),
          nextEventDate,
          lastLocation || {},
          startLimit,
          endLimit,
          opDateBegin,
          opDateEnd
        );
        const r = R.unnest([daysForEvent, daysForBase]);
        return [lastLocation, r];
      },
      device.location,
      eventsTuples
    );

    const cells = R.concat(initialEvents, R.unnest(eventsBlocks));

    const firstRow = R.head(cells);
    const secondRow = R.compose(R.head, R.tail)(cells);
    const shouldDisplayWarning = () => {
      return device.displacement.displaced;
    };
    const newFirstRow = (
      <firstRow.type id={firstRow.props.id} key={firstRow.props.id}>
        <firstRow.props.children.type
          {...firstRow.props.children.props}
          extraText=""
          //textValue={`${device.model}`}
          textValue={this.buildLinkForGps(device)}
          //secundaryTextValue={this.buildLocationGps(device)} 
          secundaryTextValue={firstRow.props.children.props.secundaryTextValue}
          textColor={"blue"}
          textWeight={"bold"}
        >
          {shouldDisplayWarning() ? <StyledError /> : ""}
        </firstRow.props.children.type>
      </firstRow.type>
    );
    const newSecondRow = (
      <secondRow.type id={secondRow.props.id} key={`s_${secondRow.props.id}`}>
        <secondRow.props.children.type
          {...secondRow.props.children.props}
          extraText=""
          textValue={`${device.model}`}
          //textValue={this.buildLinkForGps(device)}
          textColor={"red"}
          textWeight={"bold"}
        />
      </secondRow.type>
    );
    const cells2 = R.unnest([
      [newFirstRow],
      [newSecondRow],
      R.compose(R.tail, R.tail)(cells)
    ]);

    let elements = [];
    let cont = 1;
     
    /* let locat = null
    for (let index = 0; index < device.location.length; index++) {
      locat = device.location[index].location3letter_name;
    }  */
 
    return <Column key={`${device.id}`}> {cells2} </Column>;
  };

  render() {
    if (this.state === null || (this.state !== null && this.state.reloading)) {
      return (
        <Card>
          <LinearProgress />
        </Card>
      );
    }

    const timeline = this.buildTimeline(
      this.state.startDate,
      this.state.endDate,
      this.state.opDateBegin,
      this.state.opDateEnd
    );
    const events = this.buildEvents(
      this.state.data,
      this.state.startDate,
      this.state.endDate,
      this.state.opDateBegin,
      this.state.opDateEnd,
      this.state.location
    );
    const {
      startDate,
      endDate,
      locations,
      location,
      opDateBegin,
      opDateEnd
    } = this.state;

    const withLocation = prop(
      "location_name",
      head(filter(propEq("id", parseInt(location, 0)), locations))
    );

    return (
      <Card style={{ textAlign: "center" }}>
        <CardHeader
          title={`GPS SCHEDULE - ${location !== 0 ? withLocation.toUpperCase() : "ALL LOCATIONS"
            }`}
        />
        <CardContent>
          <BackButton>
            <Button
              size="small"
              color="primary"
              component={Link}
              to={{
                pathname: `/gps_schedule/start`,
                search: `?date_start=${startDate.format(
                  "YYYYMMDD"
                )}&date_end=${endDate.format(
                  "YYYYMMDD"
                )}&location=${location}&op_date_begin=${opDateBegin.isValid() ? opDateBegin.format("YYYYMMDD") : null
                  }&op_date_end=${opDateEnd.isValid() ? opDateEnd.format("YYYYMMDD") : null
                  }`
              }}
            >
              Pick a different city/time period
            </Button>
          </BackButton>
          <BackButton>
            <Button
              size="small"
              color="primary"
              component={Link}
              title="Back one month"
              onClick={() => this.setReload()}
              to={{
                pathname: `/gps_schedule`,
                search: `?date_start=${startDate
                  .subtract(1, "month")
                  .format("YYYYMMDD")}&date_end=${endDate
                    .subtract(1, "month")
                    .format("YYYYMMDD")}&location=${location}&op_date_begin=${opDateBegin.isValid()
                      ? opDateBegin.subtract(1, "month").format("YYYYMMDD")
                      : null
                  }&op_date_end=${opDateEnd.isValid()
                    ? opDateEnd.subtract(1, "month").format("YYYYMMDD")
                    : null
                  }`
              }}
            >
              <ArrowUpward />
            </Button>
          </BackButton>
          <Grid>
            {timeline}
            <Table>{events}</Table>
          </Grid>
        </CardContent>
      </Card>
    );
  }
}

export default GpsSchedule;



// WEBPACK FOOTER //
// ./src/components/gpsSchedule.js